import { AxiosResponse } from "axios";
import { AuthEnums } from "models/enums";
import { AccountingFormTypes } from "models/formTypes";
import useAPIClientHelper from "./useAPIClientHelper";
import {
  WintUtilsWebApi,
  WintSuperkollAPIModel as ApiModels,
  WintSuperkollAPIModelAccounting,
} from "wint-api-client/dist/types";

function useTransactionService() {
  const { apiClientInstance } = useAPIClientHelper();

  const get = (
    pagination: WintUtilsWebApi.Filter,
    formFilter?: AccountingFormTypes.CompanyBooksReportFilter,
    searchText?: string
  ): Promise<AxiosResponse<WintUtilsWebApi.ListResponse<WintSuperkollAPIModelAccounting.Transaction>>> => {
    return apiClientInstance(AuthEnums.AuthType.Company).TransactionClient.Get({
      ...pagination,
      ...reportToAPIFilter(formFilter),
      text: searchText,
    });
  };

  const reportToAPIFilter = (
    formFilter?: AccountingFormTypes.CompanyBooksReportFilter
  ): Omit<WintSuperkollAPIModelAccounting.TransactionFilter, keyof WintUtilsWebApi.Filter> => {
    return {
      bookingDateStart: formFilter?.bookingDate?.start,
      bookingDateEnd: formFilter?.bookingDate?.end,
      accountStart: formFilter?.account?.lowest,
      accountEnd: formFilter?.account?.highest,
      accounts: formFilter?.accountNumbers?.map((a) => a.id as string),
      voucherNumberStart: formFilter?.voucherNumber?.lowest,
      voucherNumberEnd: formFilter?.voucherNumber?.highest,
      maxAmount: formFilter?.amount?.highest,
      minAmount: formFilter?.amount?.lowest,
      series: formFilter?.series?.map((s) => s.id as string),
      categoryId: formFilter?.categoryId,
      dimensions: formFilter?.dimensions,
      includeUB: false,
      iBBookingDateStart: false,
      includeDeletedTransactions: true,
      type: ApiModels.ShowVoucherTypes.OnlyNotRemovedSameDay,
      missingReference: false,
      includeVoucher: false,
      useAuditCategories: formFilter?.isAudit ?? false,
    };
  };
  const getSeries = () => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .TransactionClient.GetSeries()
      .then((res) => res.data);
  };

  const getCategories = () => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .TransactionClient.GetCategories()
      .then((res) => res.data);
  };
  return {
    get,
    reportToAPIFilter,
    getSeries,
    getCategories,
  };
}

export default useTransactionService;
